var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPagenext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66203 0.296849L12.6025 9.11622C13.1325 9.58649 13.1325 10.4135 12.6025 10.883L2.66202 19.7024C2.17406 20.1351 1.42739 20.0909 0.994709 19.6029L0.605522 19.1643C0.172846 18.6764 0.217071 17.9297 0.70503 17.497L9.15585 10L0.705768 2.50298C0.21781 2.0703 0.172847 1.32362 0.60626 0.835667L0.995448 0.397094C1.42812 -0.0908652 2.1748 -0.135089 2.66276 0.297587L2.66203 0.296849Z",
    fill: "#55C595"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagenext);
export default __webpack_public_path__ + "static/media/icon_pagenext.bff65838f95ecccfc7780bb9bc3fb387.svg";
export { ForwardRef as ReactComponent };